U = window.U || {};
U.Index = U.Index || {};
U.Util = U.Util || {};
U.Global = U.Global || {};
U.Settings = U.Settings || {
	easing: 'easeInOutExpo'
};


U.Global.initNavbar = function() {
}

U.Global.init = function() {
	if (window.is_safari) {
		// only on safari, beforeunload doesn't fire.. 
		// but I also know that this method causes a dialog in older browsers.
		window.onbeforeunload = function() {
			$("html").addClass('is-unloading');
		};		
	}
	$(window).on('beforeunload', function() {
		// $('html, body').fadeOut('normal');
		$("html").addClass('is-unloading');
	})
	// $('html').fadeIn('normal');
	$("html").addClass('is-loading');

}


U.Index.init = function() {

	// $("[data-see-story]").click(function(ev) {
	// 	ev.preventDefault();
	// 	var $allContent = $(".collection-slide-content"),
	// 		$content = $(this).closest('.collection-slide-wrapper').find('.collection-slide-content'),
	// 		$window = $(window);

	// 	$allContent.slideUp('slow', U.Settings.easing);

	// 	var namespace = '.indexSlide';
	// 	$content.stop(true, true)
	//         .animate({
	//             height: "toggle",
	//             opacity: "toggle"
	//         }, 1500, U.Settings.easing);

 //        $content.find('.product-nav');

	// })

	var fillVideoVertically = function(parent, video){
	  document.querySelector(video).addEventListener('loadeddata', function() {
	    // Video is loaded and can be played
	    var $parent = $(parent)
	    var $video = $(video)
	    var parentHeight = $parent.height()
	    var parentWidth = $parent.width()
	    $video.css({ height: parentHeight })
	    // Now the height had been fixed, check the images new width
	    var videoWidth = $video.width();
	    var leftAdjust = ( parentWidth - videoWidth ) / 2;
	    $video.css({
	      left: leftAdjust  // cut off half the difference, thereby centering the video.
	    })
	  }, false)
	}
}


$(function() {
	U.Global.init();

})


